<template>
    <b-container fluid>
        <div>
            <b-tabs content-class="mt-3">
                <b-tab title="Formulario" active>
                    <b-row>
                        <b-col cols="12" class="py-2">
                            <label for="type">Tipo:</label>
                            <b-form-input
                                type="text"
                                size="sm"
                                id="type"
                                v-model="ticket.type"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col cols="12" class="py-2">
                            <label for="title">Titulo:</label>
                            <b-form-input
                                type="text"
                                size="sm"
                                id="title"
                                v-model="ticket.title"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col cols="12" class="py-2">
                            <label for="description">Descripción:</label>
                            <b-form-textarea
                                v-model="ticket.description"
                                disabled
                            ></b-form-textarea>
                        </b-col>
                        <b-col cols="12" md="6" class="py-2">
                            <label for="reporter"
                                >Usuario que tiene el problema:</label
                            >
                            <b-form-input
                                type="text"
                                size="sm"
                                id="reporter"
                                v-model="ticket.reporter"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col cols="12" md="6" class="py-2">
                            <label for="reporter">Para el cliente:</label>
                            <b-form-input
                                type="text"
                                size="sm"
                                id="clientProblem"
                                v-model="ticket.clientProblem"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col cols="12" md="6" class="py-2">
                            <label for="module">Módulo de Bitacorapp:</label>
                            <b-form-input
                                type="text"
                                size="sm"
                                id="moduleId"
                                v-model="ticket.moduleId"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col cols="12" md="6" class="py-2">
                            <label for="device">Dispositivo:</label>
                            <b-form-input
                                type="text"
                                size="sm"
                                id="devices"
                                v-model="ticket.device"
                                disabled
                            ></b-form-input>
                        </b-col>
                    </b-row>
                    <div v-show="enableText">
                        <hr />
                        <b-col cols="12" class="py-2">
                            <label for="description">Asunto:</label>
                            <b-form-textarea
                                v-model="moreInfo"
                                placeholder="Describa la información adicional que se requiere"
                            ></b-form-textarea>
                        </b-col>
                        <b-col cols="12" class="py-2">
                            <b-btn
                                block
                                variant="info"
                                :disabled="inProgress"
                                @click="requestInformation"
                                >Solicitar</b-btn
                            >
                            <b-btn
                                block
                                @click="closeMoreInformation"
                                :disabled="inProgress"
                                >Cancelar</b-btn
                            >
                        </b-col>
                    </div>
                    <div v-show="enableAttend">
                        <hr />
                        <b-col cols="12" class="py-2">
                            <label for="developer">Atendido por:</label>
                            <app-form-select-input
                                :options="superAdmins"
                                v-model="developer"
                            >
                            </app-form-select-input>
                        </b-col>
                        <b-col cols="12" class="py-2">
                            <label for="priority">Prioridad:</label>
                            <app-form-select-input
                                :options="priorities"
                                v-model="priority"
                            >
                            </app-form-select-input>
                        </b-col>
                        <b-col cols="12" class="py-2">
                            <b-btn
                                block
                                variant="success"
                                id="btnAttendReq"
                                @click="attendRequest"
                                >Atender</b-btn
                            >
                            <b-btn
                                block
                                @click="closeFieldsAttend"
                                id="btnCancelReq"
                                >Cancelar</b-btn
                            >
                        </b-col>
                    </div>
                    <div v-show="enableCloseReq">
                        <hr />
                        <b-col cols="12" class="py-2">
                            <label for="description"
                                >¿Esta seguro de cerrar el ticket?</label
                            >
                        </b-col>
                        <b-col cols="12" class="py-2">
                            <b-btn
                                variant="danger"
                                id="btnConfirm"
                                block
                                @click="confirmCloseTicket"
                                >Confirmar</b-btn
                            >
                            <b-btn
                                @click="disableCloseReq"
                                id="btnCancelCloseTicket"
                                block
                                >Cancelar</b-btn
                            >
                        </b-col>
                    </div>
                    <div v-show="enableFinalizeTick">
                        <hr />
                        <label for="description">Asunto:</label>
                        <b-form-textarea
                            v-model="noteFinalize"
                            placeholder="Ingrese acá una nota"
                        ></b-form-textarea>
                        <br />
                        <label for="images">Archivo</label>
                        <b-form-file v-model="file"></b-form-file>
                        <br />
                        <b-col cols="12" class="py-2">
                            <b-btn
                                variant="success"
                                id="btnConfirm"
                                block
                                @click="finalizeTicket"
                                >Finalizar</b-btn
                            >
                            <b-btn
                                @click="finalizeTicketDisable"
                                id="btnCancelCloseTicket"
                                block
                                >Cancelar</b-btn
                            >
                        </b-col>
                    </div>
                </b-tab>
                <b-tab title="Archivos">
                    <b-container fluid class="p-4">
                        <div v-if="photos.length">
                            <b-row>
                                <b-col v-for="p in photos" :key="p.id">
                                    <b-link
                                        width="120"
                                        height="120"
                                        :href="p.file_url"
                                        target="_blank"
                                        >{{ p.name }}</b-link
                                    >
                                </b-col>
                            </b-row>
                        </div>
                        <div v-else>
                            <p>no hay imagenes</p>
                        </div>
                    </b-container>
                </b-tab>
                <b-tab title="Notas">
                    <b-row>
                        <b-col>
                            <div>
                                <b-form-textarea
                                    id="textarea"
                                    v-model="note"
                                    placeholder="ingrese alguna nota..."
                                    rows="3"
                                    max-rows="6"
                                ></b-form-textarea>
                            </div>
                        </b-col>
                        <b-col cols="12" md="4" lg="2">
                            <b-button
                                variant="primary"
                                id="btnSendPagSupp"
                                class="btn-block"
                                @click="sendNote"
                                :disabled="inProgress"
                                >Enviar</b-button
                            >
                        </b-col>
                    </b-row>
                    <br />
                    <b-row>
                        <b-col>
                            <b-row
                                class="mb-2"
                                v-for="(note, i) in ticket.ticketNotes"
                                :key="note.id"
                                :class="{ even: i % 2 === 0, odd: i % 2 !== 0 }"
                            >
                                <b-col>{{ note.user.name }}</b-col>
                                <b-col cols="6">{{ note.note }}</b-col>
                                <b-col>{{ note.created_at | datetime }}</b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-tab>
            </b-tabs>
        </div>
    </b-container>
</template>
<script>
export default {
    data: () => ({
        ticket: {
            id: '',
            title: '',
            description: '',
            reporter: '',
            clientProblem: '',
            device: '',
            moduleId: '',
            type: '',
            globalIdUser: 0,
            notes: [],
        },
        note: '',
        noteFinalize: '',
        userNote: false,
        flagNoteSupport: true,
        enableText: false,
        enableAttend: false,
        enableCloseReq: false,
        enableFinalizeTick: false,
        moreInfo: '',
        developer: '',
        priority: '',
        images: [],
        users: [],
        clients: [],
        modules: [],
        photos: [],
        superAdmins: [],
        priorities: [],
        statuses: [],
        devices,
        ticketNotes: [],
        file: '',
    }),
    methods: {
        async sendNote() {
            if (this.note) {
                const { data } = await repo.post(
                    `tickets/${this.ticket.id}/send-notes`,
                    {
                        note: this.note,
                        flag: this.flagNoteSupport,
                    }
                )
                if (data.status) {
                    toastr.success(data.msg)
                    this.ticket.ticketNotes = data.ticketNoteUser
                    this.userNote = true
                    this.note = ''
                    this.$emit('ticket-saved-note')
                } else {
                    toastr.error(data.msg)
                }
            } else {
                toastr.error('ingrese una nota')
            }
        },
        fill(ticket) {
            this.resetInputs()
            this.consultStatuses(ticket.ticket_status.slug)
            this.enableAttend = false
            this.enableText = false
            this.enableCloseReq = false
            this.enableFinalizeTick = false
            this.ticket.id = ticket.id
            this.ticket.type = ticket.error_type
            this.ticket.title = ticket.title
            this.ticket.description = ticket.description
            this.ticket.moduleId = ticket.module.name
            this.photos = ticket.ticket_files
            this.ticket.reporter = ticket.reporter.name
            this.ticket.clientProblem = !!ticket.client
                ? ticket.client.name
                : ''
            this.loadDevice(ticket.device)
            this.ticket.globalIdUser = ticket.user_id
            this.ticket.ticketNotes = ticket.ticket_notes
        },
        moreInformation() {
            this.enableText = true
            this.enableAttend = false
            this.enableCloseReq = false
        },
        closeRequestEnable() {
            this.enableCloseReq = true
            this.enableText = false
            this.enableAttend = false
            this.enableFinalizeTick = false
        },
        disableCloseReq() {
            this.enableCloseReq = false
        },
        attendRequestEnable() {
            this.enableAttend = true
            this.enableCloseReq = false
            this.enableText = false
        },
        finalizeTicketEnable() {
            this.enableFinalizeTick = true
            this.enableCloseReq = false
            this.enableText = false
            this.enableAttend = false
        },
        async consultStatuses(slug) {
            if (slug.includes('en-atencion')) {
                this.$emit('attended')
            } else if (slug.includes('cerrado')) {
                this.$emit('closed')
            } else if (slug.includes('finalizado')) {
                this.$emit('closed')
            } else if (slug.includes('solicitado')) {
                this.$emit('requested')
            } else if (slug.includes('en-revision')) {
                this.$emit('inReview')
            }
        },
        async finalizeTicket() {
            const formData = new FormData()
            formData.append('note', this.noteFinalize)
            if (this.file) {
                formData.append('file[]', this.file)
            }

            const { data } = await repo.post(
                `tickets/${this.ticket.id}/finalize`,
                formData
            )
            if (data.status) {
                toastr.success(data.msg)
                this.noteFinalize = ''
                this.file = ''
                this.$emit('ticket-saved', data.ticket)
                this.$bus.$emit('ticket-finalized.load')
            } else {
                return toastr.error(data.msg)
            }
        },
        async confirmCloseTicket() {
            const { data } = await repo.post(
                `tickets/${this.ticket.id}/close-request`
            )
            if (data.status) {
                toastr.success(data.msg)
                this.$emit('ticket-saved', data.ticket)
                this.$bus.$emit('ticket-closed.load')
            } else {
                return toastr.error(data.msg)
            }
        },
        async attendRequest() {
            if (this.developer && this.priority) {
                const { data } = await repo.post(
                    `tickets/${this.ticket.id}/attend`,
                    {
                        developer: this.developer,
                        priority: this.priority,
                    }
                )
                if (data.status) {
                    toastr.success(data.msg)
                    this.developer = ''
                    this.priority = ''
                    this.$emit('ticket-saved', data.ticket)
                } else {
                    return toastr.error(data.msg)
                }
            } else {
                return toastr.error('seleccione los datos')
            }
        },
        async requestInformation() {
            if (this.moreInfo) {
                const {
                    data,
                } = await repo.post(
                    `tickets/${this.ticket.id}/request-information`,
                    { note: this.moreInfo }
                )
                if (data.status) {
                    toastr.success(data.msg)
                    this.moreInfo = ''
                    this.$emit('ticket-saved', data.ticket)
                }
            } else {
                toastr.error('ingrese el asunto de la solicitud')
            }
        },
        closeMoreInformation() {
            this.enableText = false
        },
        closeFieldsAttend() {
            this.enableAttend = false
        },
        finalizeTicketDisable() {
            this.enableFinalizeTick = false
        },
        loadDevice(dev) {
            for (var key in this.devices) {
                if (this.devices[key].value === dev) {
                    this.ticket.device = this.devices[key].text
                }
            }
        },
        async loadPhotos(id) {
            const { data } = await repo.get('tickets/photos/' + id)
            this.photos = data
        },
        async loadModulesByID(id) {
            if (id) {
                const { data } = await repo.get('tickets/modules/' + id)
                this.ticket.moduleId = data.name
            } else {
                this.ticket.moduleId = ''
            }
        },
        async loadUsersByID(id) {
            if (id) {
                const { data } = await repo.get('tickets/users/' + id)
                this.ticket.reporter = data.name
            } else {
                this.ticket.reporter = ''
            }
        },
        async loadClientsByID(id) {
            if (id) {
                const { data } = await repo.get('tickets/clients/' + id)
                this.ticket.clientProblem = data.name
            } else {
                this.ticket.clientProblem = ''
            }
        },
        async loadSuperUsers() {
            const { data } = await repo.get('users', {
                profileslug: 'super_admin',
            })
            this.superAdmins = data
        },
        async loadPriorities() {
            const { data } = await repo.get('tickets/priorities')
            this.priorities = data
        },
        reset() {
            Object.keys(this.ticket).map(key => (this.ticket[key] = ''))
            this.photos = []
            this.images = []
        },
        resetInputs() {
            this.developer = ''
            this.priority = ''
            this.moreInfo = ''
            this.noteFinalize = ''
            this.file = ''
            this.note = ''
        },
    },
    mounted() {
        this.loadPriorities()
        this.loadSuperUsers()
    },
}
const devices = [
    {
        value: 'pc',
        text: 'Computador',
    },
    {
        value: 'tablet',
        text: 'Tablet',
    },
    {
        value: 'celular',
        text: 'Celular',
    },
    {
        value: 'todos',
        text: 'Todos',
    },
]
</script>
